module.exports = __webpack_public_path__ + "static/media/HowItWorkImage1.a5f6e2e2.jpg";